import PropTypes from 'prop-types'
import { ReactComponent as DropDownIcon } from '../../../../assets/images/common/icons/drop-down-arrow.svg'
import { UncontrolledPopover } from 'reactstrap'
import classNames from 'classnames'
import { CSVLink } from 'react-csv'

import classes from './DownloadButton.module.scss'

const DownloadButton = ({ multiaction, loading, disabled, onClick, downloadPDF, csv, type, eventName }) => (
  <>
    <button
      id={`${type}-reports-download-button`}
      className={classNames('btn btn-primary d-flex align-items-center w-100', classes.downloadButton)}
      onClick={onClick}
      disabled={disabled}
    >
      <div className='flex-grow-1 d-flex justify-content-center'>
        {loading ?
          <span>
            Loading Report
            <i className='fa fa-spinner fa-spin ml-2' aria-hidden='true'/>
          </span>
          :
          <span>
            Download Report
            { multiaction && <DropDownIcon stroke='white' style={{ marginLeft: '0.3rem' }} /> }
          </span>
        }
      </div>
    </button>
    {multiaction &&
    <UncontrolledPopover
      placement='bottom'
      target={`${type}-reports-download-button`}
      trigger='legacy'
      popperClassName={classes.popper}
    >
      <div className='d-flex flex-column pt-1 pb-2'>
        <p
          className={classes.buttonAction}
          onClick={() => {
            document.body.click()
            downloadPDF()
          }}
          aria-hidden='true'>
            PDF
        </p>
        <CSVLink
          className={classes.buttonAction}
          data={csv.data}
          onClick={() => document.body.click()}
          headers={csv.headers}
          filename={`${eventName}_${type}.csv`}
        >
          CSV
        </CSVLink>
      </div>
    </UncontrolledPopover>
    }
  </>
)

DownloadButton.propTypes = {
  multiaction: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  downloadPDF: PropTypes.func,
  csv: PropTypes.shape({
    data: PropTypes.array,
    headers: PropTypes.object,
  }),
  type: PropTypes.string,
  eventName: PropTypes.string,
}

export default DownloadButton
